import { styled } from '@mui/material/styles';

import { Footer } from '../../../molecules/MainWithFooterTemplate/Footer';

export const FooterStyled = styled(Footer)({
	'&.mobile': { borderRadius: '16px 16px 0 0' },
});
